exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dashboardUtilization-daf59{margin-bottom:40px;padding:16px 24px;background-color:#fff}.dashboardUtilization-daf59 .container-35ef8{display:flex;justify-content:space-between}.dashboardUtilization-daf59 .container-35ef8>div{width:48%}", ""]);

// Exports
exports.locals = {
	"dashboardUtilization": "dashboardUtilization-daf59",
	"container": "container-35ef8"
};